// extracted by css-extract-rspack-plugin
export default {"containsTaskList":"containsTaskList__YnT"};